/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */

/* angular imports */
import { createAction, props } from '@ngrx/store';
import { AiFunctionCall, NewAiFunctionCall } from '@rappider/rappider-sdk';

/* action types */
export enum ActionTypes {
  GetAiFunctionCalls = '[AiFunctionCall] GetAiFunctionCalls',
  GetAiFunctionCallsSuccessful = '[AiFunctionCall] GetAiFunctionCallsSuccessful',
  GetAiFunctionCallsFailure = '[AiFunctionCall] GetAiFunctionCallsFailure',
  CreateAiFunctionCall = '[AiFunctionCall] CreateAiFunctionCall',
  CreateAiFunctionCallSuccessful = '[AiFunctionCall] CreateAiFunctionCallSuccessful',
  CreateAiFunctionCallFailure = '[AiFunctionCall] CreateAiFunctionCallFailure',
  UpdateAiFunctionCall = '[AiFunctionCall] UpdateAiFunctionCall',
  UpdateAiFunctionCallSuccessful = '[AiFunctionCall] UpdateAiFunctionCallSuccessful',
  UpdateAiFunctionCallFailure = '[AiFunctionCall] UpdateAiFunctionCallFailure',
  DeleteAiFunctionCall = '[AiFunctionCall] DeleteAiFunctionCall',
  DeleteAiFunctionCallSuccessful = '[AiFunctionCall] DeleteAiFunctionCallSuccessful',
  DeleteAiFunctionCallFailure = '[AiFunctionCall] DeleteAiFunctionCallFailure',
  ErrorAction = '[AiFunctionCall] ErrorAction',
  ResetStateToInitial = '[AiFunctionCall] ResetStateToInitial',
  ResetStateToInitialChangeProject = '[AiFunctionCall] ResetStateToInitialChangeProject'
}

/* actions */

export const GetAiFunctionCalls = createAction(ActionTypes.GetAiFunctionCalls);

export const GetAiFunctionCallsSuccessful = createAction(
  ActionTypes.GetAiFunctionCallsSuccessful,
  props<{ payload: { aiFunctionCalls:  AiFunctionCall[] } }>()
);

export const GetAiFunctionCallsFailure = createAction(ActionTypes.GetAiFunctionCallsFailure);

export const CreateAiFunctionCall = createAction(
  ActionTypes.CreateAiFunctionCall,
  props<{ payload: { newEntity: NewAiFunctionCall } }>()
);

export const CreateAiFunctionCallSuccessful = createAction(
  ActionTypes.CreateAiFunctionCallSuccessful,
  props<{ payload: { newEntity: AiFunctionCall } }>()
);

export const CreateAiFunctionCallFailure = createAction(ActionTypes.CreateAiFunctionCallFailure);

export const UpdateAiFunctionCall = createAction(
  ActionTypes.UpdateAiFunctionCall,
  props<{ payload: { id: string; updatedData: Partial<AiFunctionCall> } }>()
);

export const UpdateAiFunctionCallSuccessful = createAction(
  ActionTypes.UpdateAiFunctionCallSuccessful,
  props<{ payload: { id: string; updatedData: Partial<AiFunctionCall> } }>()
);

export const UpdateAiFunctionCallFailure = createAction(ActionTypes.UpdateAiFunctionCallFailure);

export const DeleteAiFunctionCall = createAction(
  ActionTypes.DeleteAiFunctionCall,
  props<{ payload: { id: string } }>()
);

export const DeleteAiFunctionCallSuccessful = createAction(
  ActionTypes.DeleteAiFunctionCallSuccessful,
  props<{ payload: { id: string } }>()
);

export const DeleteAiFunctionCallFailure = createAction(ActionTypes.DeleteAiFunctionCallFailure);

export const ResetStateToInitial = createAction(ActionTypes.ResetStateToInitial);

export const ErrorAction = createAction(
  ActionTypes.ErrorAction,
  props<{ payload: { error: any; key: string; timeStamp: number } }>()
);
